import { ActionDataType } from '../BaseCustomAction';
import {
  BaseQuestionGeneration,
  QUESTION_ACTION_TAGS,
  QuestionGenerationInputData,
} from './BaseQuestionGeneration';
/**
 * This custom action is used to send the time taken to render a question after it is generated
 * and unitl it is rendered on the screen using the author API
 */
class QuestionsRenderedAction extends BaseQuestionGeneration {
  name = 'Questions Rendered';

  type = ActionDataType.Time;

  prepareTags(
    input: QuestionGenerationInputData & { questionId?: string },
  ): Record<string, any> {
    // Get base tags from parent
    const baseTags = super.prepareTags(input);

    // Add question-specific ID if available
    if (input.questionId) {
      baseTags[QUESTION_ACTION_TAGS.QUESTION_ID] = input.questionId;
    }

    return baseTags;
  }
}

export default QuestionsRenderedAction;
